import { graphql } from '../../gql';
export const CurrentUserFragment = graphql(`
  fragment CurrentUser on User {
    id
    email
    firstName
    lastName
    isVerified
    jobTitle
    roleType
  }
`);
export const CustomerFragment = graphql(`
  fragment Customer on Customer {
    id
    logoUrl
    name
    rateIngestion {
      enabled
      exportFormats
    }
    shipmentDocuments {
      enabled
    }
  }
`);
